/* Qué es cada familia de cadena, para poder preguntar por NECESIDAD y no por familia.
   GENERADO por scraping-fabricantes/genera_familias_cadenas.py — no editar a mano.

   Fuentes, y qué es deducido:
    · características y por dónde abre → fichas de shop.murrplastik.de (20 fichas).
      La apertura se lee de qué modelos CAD publican; coincide uno a uno con el eje
      `openability` de su propio ChainBuilder (close/inside/outside/both).
    · abierta o cerrada en Power/HeavyLine → hoja del Bügelsteg (MP 8912803035), que dice
      «Offene … MP 52.2 … auf Rahmenstegen» y «Geschlossene … MP 52.3 … auf Kunststoff-
      oder Aluminiumdeckeln». Eso decodifica el «PLÁSTICO» de nuestra propia tarifa: es el
      material de la TAPA de la variante cerrada.
    · sufijo G = geschlossen, respaldado por «variante cerrada a partir de R60/R80».

   NO se escribe el MATERIAL de la cadena: en su ChainBuilder no es atributo de familia
   sino dos elecciones de configuración (Kettenmaterial y Stegmaterial). NO se escribe el
   AMBIENTE: no aparece en su tienda, ni en las fichas, ni en los PDF disponibles.

   `aperturaSegura:false` marca lo que sale por simetría y no por cita.
*/
window.CPC_FAMILIAS = {
 "MP 10.1": {
  "apertura": "fuera",
  "aperturaPor": "modelos CAD que publica su ficha",
  "aperturaSegura": true,
  "cierre": null,
  "desliza": false,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": false,
  "traviesa": null,
  "car": [
   "Mecanismo Easy para llenado fácil",
   "conexión de cadena con alivio de tracción",
   "Fácil de acortar y prolongar",
   "Muy flexible, elevada torsión"
  ]
 },
 "MP 14": {
  "apertura": "fuera",
  "aperturaPor": "modelos CAD que publica su ficha",
  "aperturaSegura": true,
  "cierre": null,
  "desliza": false,
  "economica": true,
  "amortiguada": false,
  "anchaDentro": false,
  "traviesa": null,
  "car": [
   "Variante económica",
   "conexión de cadena con alivio de tracción",
   "Fácil de acortar y prolongar"
  ]
 },
 "MP 15": {
  "apertura": "fuera",
  "aperturaPor": "modelos CAD que publica su ficha",
  "aperturaSegura": true,
  "cierre": null,
  "desliza": false,
  "economica": true,
  "amortiguada": false,
  "anchaDentro": false,
  "traviesa": null,
  "car": [
   "Variante económica",
   "Forma compacta (no para abrir)",
   "conexión de cadena con alivio de tracción",
   "Fácil de acortar y prolongar"
  ]
 },
 "MP 18.1": {
  "apertura": "ambos",
  "aperturaPor": "modelos CAD que publica su ficha",
  "aperturaSegura": true,
  "cierre": null,
  "desliza": false,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": false,
  "traviesa": null,
  "car": [
   "conexión de cadena con alivio de tracción",
   "Fácil de acortar y prolongar"
  ]
 },
 "MP 18.2": {
  "apertura": "ambos",
  "aperturaPor": "modelos CAD que publica su ficha",
  "aperturaSegura": true,
  "cierre": "abierta",
  "desliza": false,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": false,
  "traviesa": null,
  "car": [
   "conexión de cadena con alivio de tracción",
   "Fácil de acortar y prolongar"
  ]
 },
 "MP 20.2": {
  "apertura": "dentro",
  "aperturaPor": "modelos CAD que publica su ficha",
  "aperturaSegura": true,
  "cierre": "abierta",
  "desliza": false,
  "economica": true,
  "amortiguada": false,
  "anchaDentro": false,
  "traviesa": null,
  "car": [
   "Variante económica",
   "conexión de cadena con alivio de tracción",
   "Traviesa con charnela de film"
  ]
 },
 "MP 25 G": {
  "apertura": "cerrada",
  "aperturaPor": "el sufijo G es «geschlossen»; su tienda dice «variante cerrada a partir de R60/R80»",
  "aperturaSegura": true,
  "cierre": "cerrada",
  "desliza": false,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": false,
  "traviesa": null,
  "car": [
   "Variante cerrada a partir de R60",
   "Forma compacta"
  ]
 },
 "MP 3000": {
  "apertura": "dentro",
  "aperturaPor": "modelos CAD que publica su ficha",
  "aperturaSegura": true,
  "cierre": null,
  "desliza": false,
  "economica": true,
  "amortiguada": false,
  "anchaDentro": false,
  "traviesa": null,
  "car": [
   "Variante económica",
   "conexión de cadena con alivio de tracción"
  ]
 },
 "MP 32.2": {
  "apertura": "abierta",
  "aperturaPor": "hoja del Bügelsteg de Murrplastik: la .2 va con traviesas y la .3 con tapa",
  "aperturaSegura": true,
  "cierre": "abierta",
  "desliza": true,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Carriles de deslizamiento para una vida útil más prolongada",
   "Amplia distribución interior",
   "Enlace de cadena flexible",
   "Ejecución en plástico o aluminio"
  ]
 },
 "MP 35.1": {
  "apertura": "ambos",
  "aperturaPor": "modelos CAD que publica su ficha",
  "aperturaSegura": true,
  "cierre": null,
  "desliza": false,
  "economica": true,
  "amortiguada": true,
  "anchaDentro": false,
  "traviesa": null,
  "car": [
   "Variante económica",
   "Sistema de tope amortiguado",
   "De uso universal",
   "conexión de cadena con alivio de tracción"
  ]
 },
 "MP 35.2": {
  "apertura": "ambos",
  "aperturaPor": "modelos CAD que publica su ficha",
  "aperturaSegura": true,
  "cierre": "abierta",
  "desliza": false,
  "economica": true,
  "amortiguada": true,
  "anchaDentro": false,
  "traviesa": null,
  "car": [
   "Variante económica",
   "Sistema de tope amortiguado",
   "De uso universal",
   "conexión de cadena con alivio de tracción"
  ]
 },
 "MP 36 G": {
  "apertura": "cerrada",
  "aperturaPor": "el sufijo G es «geschlossen»; su tienda dice «variante cerrada a partir de R60/R80»",
  "aperturaSegura": true,
  "cierre": "cerrada",
  "desliza": false,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": false,
  "traviesa": null,
  "car": [
   "Variante cerrada a partir de R80",
   "Enlace de la cadena de metal"
  ]
 },
 "MP 41.2": {
  "apertura": "abierta",
  "aperturaPor": "hoja del Bügelsteg de Murrplastik: la .2 va con traviesas y la .3 con tapa",
  "aperturaSegura": true,
  "cierre": "abierta",
  "desliza": true,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Carriles de deslizamiento para una vida útil más prolongada",
   "Amplia distribución interior",
   "Enlace de cadena flexible",
   "Ejecución en plástico o aluminio"
  ]
 },
 "MP 41.3 PLÁSTICO": {
  "apertura": "cerrada",
  "aperturaPor": "hoja del Bügelsteg de Murrplastik: la .2 va con traviesas y la .3 con tapa",
  "aperturaSegura": true,
  "cierre": "cerrada",
  "desliza": true,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Carriles de deslizamiento para una vida útil más prolongada",
   "Amplia distribución interior",
   "Enlace de cadena flexible",
   "Ejecución en plástico o aluminio"
  ]
 },
 "MP45.1_45.2": {
  "apertura": "fuera",
  "aperturaPor": "modelos CAD que publica su ficha",
  "aperturaSegura": true,
  "cierre": null,
  "desliza": false,
  "economica": true,
  "amortiguada": true,
  "anchaDentro": true,
  "traviesa": null,
  "car": [
   "Variante económica",
   "Sistema de tope amortiguado",
   "De uso universal",
   "conexión de cadena con alivio de tracción",
   "Amplia distribución interior"
  ]
 },
 "MP 52_2": {
  "apertura": "abierta",
  "aperturaPor": "hoja del Bügelsteg de Murrplastik: la .2 va con traviesas y la .3 con tapa",
  "aperturaSegura": true,
  "cierre": "abierta",
  "desliza": true,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Carriles de deslizamiento para una vida útil más prolongada",
   "Amplia distribución interior",
   "Enlace de cadena flexible",
   "Ejecución en plástico o aluminio"
  ]
 },
 "MP 52_3 PLÁSTICO": {
  "apertura": "cerrada",
  "aperturaPor": "hoja del Bügelsteg de Murrplastik: la .2 va con traviesas y la .3 con tapa",
  "aperturaSegura": true,
  "cierre": "cerrada",
  "desliza": true,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Carriles de deslizamiento para una vida útil más prolongada",
   "Amplia distribución interior",
   "Enlace de cadena flexible",
   "Ejecución en plástico o aluminio"
  ]
 },
 "MP52.4": {
  "apertura": "abierta",
  "aperturaPor": "mismo patrón de variantes de la hoja del Bügelsteg (par = abierta de traviesas, impar = cerrada de tapa), pero esta serie no la nombra: SIN CONFIRMAR",
  "aperturaSegura": false,
  "cierre": "abierta",
  "desliza": false,
  "economica": true,
  "amortiguada": true,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Variante económica",
   "Sistema de tope amortiguado",
   "Enlace de cadena flexible",
   "Amplia distribución interior",
   "Ejecución en plástico o aluminio"
  ]
 },
 "MP52.5 GP": {
  "apertura": "cerrada",
  "aperturaPor": "el sufijo G es «geschlossen»; su tienda dice «variante cerrada a partir de R60/R80»",
  "aperturaSegura": true,
  "cierre": "cerrada",
  "desliza": false,
  "economica": true,
  "amortiguada": true,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Variante económica",
   "Sistema de tope amortiguado",
   "Enlace de cadena flexible",
   "Amplia distribución interior",
   "Ejecución en plástico o aluminio"
  ]
 },
 "MP 62_2": {
  "apertura": "abierta",
  "aperturaPor": "hoja del Bügelsteg de Murrplastik: la .2 va con traviesas y la .3 con tapa",
  "aperturaSegura": true,
  "cierre": "abierta",
  "desliza": true,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Carriles de deslizamiento para una vida útil más prolongada",
   "Amplia distribución interior",
   "Enlace de cadena flexible",
   "Ejecución en plástico o aluminio"
  ]
 },
 "MP 62_3 Plástico": {
  "apertura": "cerrada",
  "aperturaPor": "hoja del Bügelsteg de Murrplastik: la .2 va con traviesas y la .3 con tapa",
  "aperturaSegura": true,
  "cierre": "cerrada",
  "desliza": true,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Carriles de deslizamiento para una vida útil más prolongada",
   "Amplia distribución interior",
   "Enlace de cadena flexible",
   "Ejecución en plástico o aluminio"
  ]
 },
 "MP 62.4": {
  "apertura": "abierta",
  "aperturaPor": "mismo patrón de variantes de la hoja del Bügelsteg (par = abierta de traviesas, impar = cerrada de tapa), pero esta serie no la nombra: SIN CONFIRMAR",
  "aperturaSegura": false,
  "cierre": "abierta",
  "desliza": false,
  "economica": true,
  "amortiguada": true,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Variante económica",
   "Sistema de tope amortiguado",
   "Enlace de cadena flexible",
   "Amplia distribución interior",
   "Ejecución en plástico o aluminio"
  ]
 },
 "MP 82_2": {
  "apertura": "abierta",
  "aperturaPor": "hoja del Bügelsteg de Murrplastik: la .2 va con traviesas y la .3 con tapa",
  "aperturaSegura": true,
  "cierre": "abierta",
  "desliza": true,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Carriles de deslizamiento para una vida útil más prolongada",
   "Amplia distribución interior",
   "Enlace de cadena flexible",
   "Ejecución en plástico o aluminio"
  ]
 },
 "MP 102_2": {
  "apertura": "abierta",
  "aperturaPor": "mismo patrón de variantes de la hoja del Bügelsteg (par = abierta de traviesas, impar = cerrada de tapa), pero esta serie no la nombra: SIN CONFIRMAR",
  "aperturaSegura": false,
  "cierre": "abierta",
  "desliza": false,
  "economica": false,
  "amortiguada": false,
  "anchaDentro": true,
  "traviesa": "ambos",
  "car": [
   "Amplia distribución interior",
   "Enlace de la cadena como ángulo de acero",
   "Ejecución en plástico o aluminio"
  ]
 }
};
